import { SVGProps } from "react";

const BatteryWarning = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-batería-muy-baja"
      {...props}
    >
      <path
        d="M14.167 7.5H16.167C16.6974 7.5 17.2061 7.71071 17.5812 8.08579C17.9563 8.46086 18.167 8.96957 18.167 9.5V15.5C18.167 16.5 17.167 17.5 16.167 17.5H14.167M6.16699 7.5H4.16699C3.63656 7.5 3.12785 7.71071 2.75278 8.08579C2.37771 8.46086 2.16699 8.96957 2.16699 9.5V15.5C2.16699 16.5 3.16699 17.5 4.16699 17.5H6.16699M22.167 11.5V13.5M10.167 7.5V13.5M10.167 17.5V17.51"
        stroke="#FAFAFA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BatteryWarning;
